/*!
 * @copyright
 * Copyright(c) 2018 SICK AG
 */
import { Vector3 } from 'three';
/**
 * helps to project 2D points into the 3D Space
 * in such a way that the 3D point is visual behind the 2D Point
 */
export class Pointer {
    /**
     * constructor
     * @param camera camera of the current 3D space
     */
    constructor(camera) {
        this._camera = camera;
        this.setupBasicMode();
    }
    setupBasicMode(point) {
        this._constraintAxis = undefined;
        this._normal = undefined;
        this.changePoint(point || new Vector3());
    }
    setupAxisMode(axis, point) {
        this._constraintAxis = axis.clone().normalize();
        const a = new Vector3();
        a.copy(this._camera.position).sub(point);
        const orthopos = this._constraintAxis.clone().multiplyScalar(this._constraintAxis.dot(a)).add(point);
        this._normal = new Vector3();
        this._normal.copy(this._camera.position).sub(orthopos).normalize();
        this.changePoint(point);
    }
    /**
     * sets set normal of the plane where the mouse is projected to
     * @param normal the normal of the projection plane or if n === undefined a plane that is 'always' parallel to the camera
     */
    setupPlaneMode(normal, point) {
        this._constraintAxis = undefined;
        this._normal = normal.clone();
        this.changePoint(point);
    }
    /**
     * sets any point on the plane or Axis
     * @param point
     */
    changePoint(point) {
        this._point = point;
        this._distance = this._camera.position.clone().sub(point).dot(this._acquireNormal());
    }
    /**
     * projects a 2d point to 3D space
     * @param x any point between -1..1
     * @param y any point between -1..1
     */
    to3DSpace(x, y) {
        const svec = new Vector3(x, y, 0.5);
        const v = svec.unproject(this._camera).sub(this._camera.position).normalize();
        let a = this._acquireNormal().dot(v);
        if (a === 0) { // TODO : find a better way !
            a = -1;
        }
        const p = v.multiplyScalar(-this._distance / a).add(this._camera.position);
        if (this._constraintAxis != null) {
            const s = (p.sub(this._point)).dot(this._constraintAxis);
            p.copy(this._constraintAxis).multiplyScalar(s).add(this._point);
        }
        return p;
    }
    _acquireNormal() {
        const wdir = new Vector3();
        this._camera.getWorldDirection(wdir);
        if (this._normal === undefined) {
            return wdir.negate();
        }
        return this._normal;
    }
}
//# sourceMappingURL=Pointer.js.map